import { authentication } from "./app-database";
const initialState = {
	"loading": false,
	"loader": false,
	"stateInitialized": false,
	"navegacionDesde": "",
	"navegacionHacia": "",
	"tid" : false,
	"uid" : false,
	"jwt" : false,
	"nombre": "",
	"lastlogin": false,
	"clienteUnico": "",
	"downloadProgress": 0,
	"beta": false,
	"online": true,
	"conectaMovil": false
};

export function appRdc(state = initialState, action) {
	switch (action.type) {
	case "GLOBAL_MOSTRAR_CARGANDO":
		return {...state,
			"loading": true
		};
	case "GLOBAL_ESCONDER_CARGANDO":
		return {...state,
			"loading": false
		};
	case "LOADER_SHOW":
		return {...state,
			"loader": true
		};
	case "LOADER_HIDE":
		return {...state,
			"loader": false
		};
	case "LOADER":
		return {...state,
			"loader": action.show
		};
	case "NAVEGACION":
		return {...state,
			"navegacionDesde": action.navDesde,
			"navegacionHacia": action.navHacia
		};
	case "INITIALIZE_STATE": 
		return {...state,
			"stateInitialized": true
		};
	case "INITIALIZE_STATE_FALSE":
		return {...state,
			"stateInitialized": false
		};
	case "TOKEN":
		return {...state,
			"tid": action.tid,
			"uid": action.uid
		};
	case "REFRESH_TOKEN":
		return {...state,
			"refreshToken": action.refreshToken
		};
	case "JWT":
		return {...state,
			"jwt": action.jwt
		};
	case "CARGAR_SESION": 
		return {...state,
			"nombre": action.nombre,
			"lastlogin": action.lastlogin
		};
	case "DATOS_FISCALES":
		return{...state,
			savedDatosFiscales:action.saved
		};
	case "LOAD_TOKEN":
		authentication.signInWithCustomToken(action.jwt);
		return {...state};
	case "CVE_CLIENTE_UNICO":
		var sClienteUnico = "" + action.uid;
		while (sClienteUnico.length < 10) {
			sClienteUnico = "0" + sClienteUnico;
		}
		return {...state,
			"clienteUnico": sClienteUnico
		};
	case "DOWNLOADING": 
		return {...state,
			"downloadProgress": action.progress * 100
		};
	case "DOWNLOADED": 
		return {...state,
			"downloadProgress": 100
		};
	case "BETA": 
		return {...state,
			"beta": action.beta
		};
	case "NAVIGATOR_ONLINE": 
		return {...state,
			"online": true 
		};
	case "NAVIGATOR_OFFLINE": 
		return {...state,
			"online": true 
		};
	case "GLOBAL_CONECTA_MOVIL": 
		return {...state,
			"conectaMovil": action.conectaMovil 
		};
	case "GLOBAL_DISPOSITIVO":
		return {...state,
			"dispositivo": action.dispositivo 
		};
	default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/app-reducer.js